import i18n from 'i18n-js';
import { RotateModalProps } from '@v2/components/imageHandling/components/Header/components/RotateModal';

interface UseManageRotateModalParams extends Pick<RotateModalProps, 'rotateImage' | 'images' | 'selectedIndex'> {}

export const useManageRotateModal = ({ rotateImage, images, selectedIndex }: UseManageRotateModalParams) => {
  const selectedImage = images[selectedIndex];

  const onRotate = (onePage: boolean) => {
    if (!selectedImage) return;

    rotateImage({ documentId: selectedImage.documentId, onePage });
  };

  const list = [
    {
      title: i18n.t('Rotate page'),
      icon: 'file',
      onPress: () => onRotate(true),
      color: 'Label/Light/Primary',
      width: 20,
      height: 20,
    } as const,
    {
      title: i18n.t('Rotate document'),
      icon: 'files',
      color: 'Label/Light/Primary',
      onPress: () => onRotate(false),
      width: 20,
      height: 20,
    } as const,
  ];

  return { list };
};
